<script>
  import Member from './Member.svelte';
  import Modal from './Modal.svelte';
  import Map from './Map.svelte';
  import { fade } from 'svelte/transition';

  export let character = {};

  let modal = {};
  const handleMapModal = () => {
    modal = {
      component: Map,
      character,
    };
  }
</script>

<style>
  .section-label {
    margin-top: 0;
  }
  .fullname {
    margin-bottom: 1em;
  }
  .pic img {
    height: 100px;
  }
  .about .section-label {
    margin-top: 0.5em;
  }
  button {
    float: right;
    text-transform: uppercase;
  }

  :global(.modal) .character :global(button) {
    margin-right: 2rem;
  }

  @media (min-width: 1024px) {
    .character {
      border-top: 1px dashed #9D9D9D;
      margin-top: 2rem;
      padding-top: 2rem;
    }

    /* Hide some features when in a modal */
    :global(.modal) .character {
      border-top: none;
      margin-top: 0;
      padding-top: 0;
    }
    :global(.modal) .character :global(button) {
      display: none;
    }
  }
</style>

{#if 'name' in character}
<div class:character in:fade>
  <button class="button" on:click={handleMapModal}>View Map</button>
  <div class="section-label larger">{character.name}</div>
  <div class="fullname">
    <em><strong>Official name:</strong> {character.fullname}</em>
  </div>
  {#if character.imgs.length}
  <div class="pic bordered-image">
    {#each character.imgs as url}
      <img src="{url}" alt="{character.name}">
    {/each}
  </div>
  {/if}

  <div class="about">
    <div class="section-label">Profile</div>
    {#if character.bio}
    {@html character.bio}
    {/if}

    {#if character.members.length}
    <div class="members">
      <div class="section-label">Select Members</div>
      {#each character.members as member}
        <Member member={member}/>
      {/each}
    </div>
    {/if}
  </div>
</div>
{/if}

{#if 'component' in modal}
<Modal on:close="{() => modal = {}}">
  <slot>
    <svelte:component this={modal.component} {...modal}/>
  </slot>
</Modal>
{/if}